// frontend/src/App.js
import React, { useState } from "react";
import Login from "./components/Login";
import "./App.css";
//import Header from "./components/Header";
import NodeManager from "./components/NodeManager";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Recover from './components/Recover'
import Reset from './components/Reset'
import Join from './components/Join'
import { useCookies } from 'react-cookie'

function App() {
  
  const baseUrl= process.env.REACT_APP_MGR_DOMAIN + process.env.REACT_APP_MGR_PATH;
  const baseDir= process.env.REACT_APP_MGR_PATH;

  const [token, setToken] = useState("");
  const userToken = (tok) => {
    setToken(tok);
  };

  const [user, setUser] = useState("");
  const userLogin = (usr) => {
    setUser(usr);
  };
const [cookies, setCookie, removeCookie] = useCookies(['spatiamtoken']);
  let tokencookie = cookies.spatiamtoken;
  if(tokencookie && !token){
    tokencookie = tokencookie.split("###");
    if(tokencookie.length === 2){
      setUser(tokencookie[0]);
      setToken(tokencookie[1]);
    } 
  }
  return (
    
    <div className="app">
      
      <Router>
        {//<Header />
        }
        <Switch>
          <Route path={baseDir+"/recover"}>
            <Recover baseUrl={baseUrl} baseDir={baseDir}/>
          </Route>
          <Route exact path={[baseDir+"/register/:uid",baseDir+"/register/"]}>
            <Login baseUrl={baseUrl} baseDir={baseDir} userToken={userToken} userLogin={userLogin} setCookie={setCookie} signin={false}/> 
          </Route>
          <Route path={baseDir+"/join"}>
            <Join baseUrl={baseUrl} baseDir={baseDir}/>
          </Route>
          <Route path={baseDir+"/reset/:uid/:token"}>
            <Reset baseUrl={baseUrl} baseDir={baseDir}/>
          </Route>
          {token ? ( 
          <Route path={[baseDir, baseDir+"/networks"]}>
          <NodeManager baseUrl={baseUrl} baseDir={baseDir} setToken={setToken} removeCookie={removeCookie} token={token} user={user} /> 
          </Route>
          ) : ( 
            <Route path={[baseDir, baseDir+"/networks"]}>
          <Login baseUrl={baseUrl} baseDir={baseDir} userToken={userToken} userLogin={userLogin} setCookie={setCookie} signin={true}/> 
          </Route>
          )}
          <Route path="/">
            <h1 style={{ color: "white", marginLeft: "200px" }}>
              404 Not Found
            </h1>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}
export default App;
//{token ? ( <NodeManager token={token} user={user} /> ) : ( <Login userToken={userToken} userLogin={userLogin} /> )}
